<template>
  <div class="sidebar" :class="isOpen ? 'open' : ''">
    <div class="left-bar">
      <b-tooltip v-for="section in sections" :key="section.title" :label="section.title" append-to-body position="is-right" :id="section.title + '-div'">
        <div class="navigationIcon" @click="SelectSection(section, section.title + '-div')">
          <div class="circleBackgroundHover">
            <b-icon :icon="section.icon" size="is-medium"></b-icon>
          </div>
        </div>
      </b-tooltip>
      <div class="background-highlight">
        <div class="colour"></div>
      </div>
      <div class="logout">
        <div class="navigationIcon" @click="isOpen = true">
          <div class="circleBackgroundHover">
            <b-icon icon="user" pack="fas" size="is-medium"></b-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="right-bar">
      <div class="hero">
        <div class="hero-body">
          <h2 class="title is-capitalized">{{ activeSection.title }}</h2>
        </div>
      </div>
      <b-menu class="is-custom-mobile">
        <template v-for="item in activeSection.navbar">
          <b-menu-item
            v-if="item.children.length == 0"
            class="menu-option is-size-5"
            :class="$route.name == activeSection.url + '-' + item.route ? 'selected' : ''"
            :key="item.label"
            :icon="item.icon"
            icon-pack="fas"
            tag="router-link"
            :to="{ name: activeSection.url + '-' + item.route }"
            @click.native="isOpen = false"
          >
            <template #label="props">
              {{ item.label }}
              <b-icon v-if="item.children.length > 0" class="is-pulled-right" :icon="props.expanded ? 'chevron-up' : 'chevron-down'"></b-icon>
            </template>
          </b-menu-item>
        </template>
        <template v-for="item in activeSection.navbar">
          <b-menu-item
            v-if="item.children.length > 0"
            class="menu-option is-size-5"
            :class="$route.name == activeSection.url + '-' + item.route ? 'selected' : ''"
            :key="item.label"
            :icon="item.icon"
            icon-pack="fas"
          >
            <template #label="props">
              {{ item.label }}
              <b-icon v-if="item.children.length > 0" class="is-pulled-right" :icon="props.expanded ? 'chevron-up' : 'chevron-down'"></b-icon>
            </template>
            <b-menu-item
              class="menu-option is-size-6"
              :class="$route.name == activeSection.url + '-' + listItem.route ? 'selected' : ''"
              v-for="listItem in item.children"
              :key="listItem.label"
              :label="listItem.label"
              :icon="listItem.icon"
              icon-pack="fas"
              tag="router-link"
              :to="{ name: activeSection.url + '-' + listItem.route }"
              @click.native="isOpen = false"
            ></b-menu-item>
          </b-menu-item>
        </template>
      </b-menu>
      <div class="user-menu">
        <div class="content-menu">
          <h2 class="title is-capitalized is-size-6">{{ $route.params.name }}</h2>
          <h3 class="subtitle is-size-7">{{ $route.params.email }}</h3>
        </div>
        <div class="logout-button" @click="logout"><b-icon icon="logout"></b-icon></div>
      </div>
    </div>
    <label class="hamburger" @click="isOpen = !isOpen">
      <span class="navicon"> </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {},
  name: "Sidebar",
  data: function () {
    return {
      isOpen: true,
      activeSection: {},
    };
  },
  methods: {
    CloseSidebar: async function () {
      this.isOpen = false;
    },
    SelectSection: async function (section, event) {
      let buttonDiv = document.getElementById(`${event}`);
      let backgroundDiv = document.getElementsByClassName(`background-highlight`)[0];
      backgroundDiv.style.top = `${buttonDiv.offsetTop + 5}px`;
      this.activeSection = section;
      this.$store.commit("ChangeSite", section);
      this.isOpen = true;
    },
    UpdateSection: async function (section) {
      this.activeSection == section.title;
      this.$store.commit("ChangeSite", section);
    },
    logout: function () {
      this.$cognitoAuth.logout();
      this.$router.push("/login");
    },
  },
  computed: {
    sections() {
      return this.$store.getters.sites;
    },
  },
  beforeMount() {
    if (this.$router.currentRoute.fullPath != "/") {
      let sectionName = this.$router.currentRoute.name.split("-")[0];
      let sectionFound = this.sections.filter((section) => {
        return section.url.toLowerCase() == sectionName.toLowerCase();
      });
      if (sectionFound.length == 1) {
        this.UpdateSection(sectionFound[0]);
      }
    }
  },
  mounted() {
    if (this.sections[0]) {
      this.activeSection = this.sections[0];
    } else {
      new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
        this.activeSection = this.sections[0];
      });
    }
  },
};
</script>

<style scoped>
.sidebar {
  height: 100%;
  transition: all 0.3s;
  color: white;
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 3fr;
  max-width: 70px;
  transition: max-width 0.2s linear;
}
.sidebar.open {
  max-width: 370px;
}
.sidebar .hamburger {
  position: absolute;
  top: 25px;
  right: 11px;
  aspect-ratio: 1;
  width: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}
.sidebar.open > .hamburger .navicon {
  background: transparent;
}
.sidebar.open > .hamburger .navicon:before {
  transform: rotate(-45deg);
  top: 5px;
  background: black;
}
.sidebar.open > .hamburger .navicon:after {
  transform: rotate(45deg);
  top: 5px;
  background: black;
}
.sidebar .hamburger .navicon {
  background: rgb(255, 255, 255);
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  width: 35px;
}
.sidebar .hamburger .navicon:before,
.sidebar .hamburger .navicon:after {
  background: rgb(255, 255, 255);
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}
.sidebar .hamburger .navicon:before {
  top: 10px;
}
.sidebar .hamburger .navicon:after {
  top: -10px;
}
.sidebar .left-bar {
  height: 100%;
  padding-top: 50px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: 70px;
  overflow: hidden;
  background-color: #3bac50;
  position: relative;
}
.sidebar .left-bar .background-highlight {
  top: 55px;
  width: 100%;
  height: 45px;
  position: absolute;
  z-index: 1;
  transition: top 0.1s;
  display: flex;
  justify-content: center;
}
.sidebar .left-bar .background-highlight .colour {
  background-color: rgba(255, 255, 255, 0.25);
  width: 80%;
  border-radius: 8px;
}
.sidebar .left-bar .b-tooltip {
  z-index: 5;
}
.sidebar .right-bar .menu-option.selected {
  background-color: rgb(71 208 97);
}
.sidebar .right-bar .menu-option.selected:hover {
  background-color: rgb(57 172 79);
}
.sidebar .right-bar {
  height: 100%;
  background-color: #e9e9e9;
  width: 300px;
  display: grid;
  grid-template-rows: 120px auto 90px;
}
.sidebar .right-bar .menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sidebar .right-bar .menu li {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  margin: 1px 5px 1px 5px;
  border-radius: 5px;
  padding: 5px 10px 5px 10px;
}
.sidebar .right-bar .menu li:hover {
  background-color: rgb(211 211 211 / 44%);
}
.center:before,
.center:after,
.center div {
  background: #fff;
  content: "";
  display: block;
  height: 4px;
  border-radius: 3px;
  margin: 7px 0;
  transition: 0.5s;
}
.center {
  width: 35px;
  position: absolute;
  top: 10px;
  right: 17.5px;
}
.navigationIcon {
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 10px 20px;
}
.navigationIcon .selected {
  outline: none;
  background-color: #00003ca6;
}
.navigationIcon:hover {
  background-color: #b3b3b354;
}
.navigationIcon .active {
  background-color: #b3b3b347;
}
.logout {
  position: absolute;
  bottom: 20px;
  left: 0;
}
.sidebarTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 78%;
  transition: 0.2s all;
  overflow: hidden;
  height: 100%;
  font-size: 1.2em;
  text-transform: capitalize;
  font-weight: bold;
  letter-spacing: 1px;
}
.tooltip-content {
  text-transform: capitalize;
}
.is-white {
  color: whitesmoke !important;
}
.user-menu {
  border-top: 1px solid lightgray;
  margin: 0px 10px;
  padding: 20px 10px;
  display: grid;
  grid-template-columns: 5fr 1fr;
  align-content: center;
  color: black;
}
.user-menu .logout-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}
.user-menu .logout-button:hover {
  background: lightgray;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .hamburger-float {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 98;
  }
  .hamburger-float .hamburger {
    position: relative;
  }
  .sidebar {
    position: fixed;
    left: -70px;
    z-index: 99;
    display: flex;
  }
  .sidebar.open {
    left: 0;
    max-width: 100vw;
  }
  .sidebar .right-bar {
    width: 100vw;
    flex-grow: 1;
  }
}
</style>

<style>
.sidebar .right-bar .menu li a {
  color: #1a2e44;
  display: grid;
  gap: 10px;
  align-items: center;
  grid-template-columns: 1fr 9fr 1fr;
}

.sidebar .right-bar .menu-option.selected a {
  color: white;
}

.sidebar .right-bar .menu-option ul {
  margin-top: 15px;
}
</style>
